class JWTUtils {
    constructor() {}

    DecodificarJWT(token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decodedPayload = decodeURIComponent(atob(base64).split('').map(item => {
            return '%' + ('00' + item.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        
        const json = JSON.parse(decodedPayload);
    
        return json;
    }

}

export const jwtUtils = new JWTUtils();